import css from "./Offerings.module.css";
import Service from "./Service";
import Resource from "./Resource";

const Offerings = () => {
  const services = [
    {
      service: "Bookkeeping",
      link: "/bookkeeping",
      img: require("./bookkeeping.png"),
      alt: "numbers",
    },
    {
      service: "Financial Consulting",
      link: "/consulting",
      img: require("./consulting.png"),
      alt: "speech bubbles",
    },
    {
      service: "New Business Registration",
      link: "/registration",
      img: require("./registration.png"),
      alt: "checkmarks",
    },
    {
      service: "Payroll",
      link: "/payroll",
      img: require("./payroll.png"),
      alt: "dollar signs",
    },
  ];

  const resources = [
    {
      name: "Business Registration Checklist",
      description: "Everything you need to start a new business.",
      link: "/resources/new-business-registration-checklist",
    },
    {
      name: "Free Finance Tracker",
      description: "A free finance tracker to organize your books.",
      link: "/resources/finance-tracker",
    },
  ];

  return (
    <>
      <div className="container background_gradient-top">
        <div className="column w64 g1">
          <h2>What we do best</h2>
          <div className={css.services}>
            {services.map((service, index) => (
              <Service key={index} service={service} />
            ))}
          </div>
        </div>
      </div>
      <div className="container" style={{ marginTop: "-4rem" }}>
        <div className="column w64 g1">
          <h3 className="ctext">Additional resources</h3>
          <div className={"columns g1"}>
            {resources.map((resource, index) => (
              <Resource key={index} resource={resource} />
            ))}
          </div>
          <a
            className="cta"
            href="https://calendar.app.google/cgho9MaUp1oADCZLA"
            target="_blank"
            rel="noopener noreferrer"
          >
            Schedule a consultation
          </a>
        </div>
      </div>
    </>
  );
};

export default Offerings;
